module.exports = "/lucky-balls/img/bigball/BigBall_014.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_014.png
// module id = 909
// module chunks = 0